"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("react"),
  t = require("prop-types"),
  i = require("./taggedTemplateLiteral-97b463ad.js"),
  r = require("styled-components");
function a(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var n,
  o = a(e),
  d = a(t),
  l = a(r)["default"].div(n || (n = i._taggedTemplateLiteral(["\n  position: relative;\n  height: 0;\n  padding-bottom: 56.25%;\n  iframe {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    border: 0;\n  }\n"]))),
  u = function u(e) {
    var t = e.height,
      i = e.id,
      r = e.title,
      a = e.width;
    return o["default"].createElement(l, {
      className: "video-container",
      "data-video-id": i
    }, o["default"].createElement("iframe", {
      allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture;",
      allowFullScreen: "",
      height: t,
      src: "https://www.youtube.com/embed/".concat(i, "?enablejsapi=1&rel=0&origin=https://northwesternmutual.com/"),
      title: r,
      width: a
    }));
  };
u.propTypes = {
  height: d["default"].number,
  id: d["default"].string.isRequired,
  title: d["default"].string.isRequired,
  width: d["default"].number
}, u.defaultProps = {
  height: 320,
  width: 600
}, exports.VideoComponent = u;